export default function BulbIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5 17.5C16.366 17.5 19.5 14.366 19.5 10.5C19.5 6.63401 16.366 3.5 12.5 3.5C8.63401 3.5 5.5 6.63401 5.5 10.5C5.5 14.366 8.63401 17.5 12.5 17.5Z"></path>
            <path d="M9.5 17V19.5H15.5V17"></path>
            <path d="M14.5 19.5H10.5V21.5H14.5V19.5Z"></path>
            <path d="M12.5 21.5V23.5"></path>
            <path d="M12.5 0.5V1.5"></path>
            <path d="M19.571 3.4292L18.864 4.1362"></path>
            <path d="M22.5 10.5H21.5"></path>
            <path d="M19.571 17.5708L18.864 16.8638"></path>
            <path d="M5.42896 3.4292L6.13596 4.1362"></path>
            <path d="M2.5 10.5H3.5"></path>
            <path d="M5.42896 17.5708L6.13596 16.8638"></path>
            <path
                d="M13 17L14.275 11.475C14.407 10.905 14.915 10.5 15.5 10.5C16.053 10.5 16.5 10.947 16.5 11.5C16.5 12.053 16.053 12.5 15.5 12.5H12.5H9.5C8.947 12.5 8.5 12.053 8.5 11.5C8.5 10.947 8.947 10.5 9.5 10.5C10.085 10.5 10.593 10.904 10.725 11.475L12 17"></path>
        </svg>
    )
}